const firebaseConfig = {
    apiKey: "AIzaSyDV6RdDt3Mgf68CwfG__PwI_NQ4su0tuaQ",
    authDomain: "creative-agency-1708007.firebaseapp.com",
    databaseURL: "https://creative-agency-1708007.firebaseio.com",
    projectId: "creative-agency-1708007",
    storageBucket: "creative-agency-1708007.appspot.com",
    messagingSenderId: "1076046501737",
    appId: "1:1076046501737:web:38c1a194e830eeb11ecff8"
};

export default firebaseConfig;